module.exports = __webpack_public_path__ + "img/female.9a74552c.png";